import React from 'react';
import { apiurl } from '../../common/constants';
import { useAuthAxios } from '../authfetch';
import { useStore } from '../../context/StoreContext';

// takes file url through the props and sends a delete request to the server to delete that file
// props takes {
//     img: product image url,
//     prodId: product ko _id,
//     index: prod_img ko index, 0 for thumbnail image  
// }

export default function Deletor(props) {
    const authAxios = useAuthAxios();
    const { productRefresh, setProductRefresh, setCurrentSelectedProduct } = useStore();
    
    const handleDelete = async () => {
        if (props.index === 0){
            alert("thumbnail image cannot be deleted without first changing thumbnail.")
            return
        }
        const payload = {
            img_to_delete: props.img,
            prodId: props.prodId
        }
        
        try {
            const { data } = await authAxios.delete(apiurl + "/products/deleteimg", { data: payload });
            alert(data.message)
            // Update currentSelectedProduct with the updated product data
            if (data.data) {
                setCurrentSelectedProduct(data.data)
            }
            if (props.callback) {
                props.callback()
            }
            setProductRefresh(productRefresh + 1)
        } catch (err) {
            console.log("err occured", err)
        }
    }
    return (
        <>
            <i className="fa-solid fa-trash-can cursor-pointer" onClick={handleDelete}></i>
        </>
    );
}

// export default Deletor;
